<template>
  <v-dialog
    :value="value"
    fullscreen
    scrollable
    persistent
    no-click-animation
    :transition="transition"
  >
    <slot />
  </v-dialog>
</template>

<script>
  export default {
    props: {
      value: {
        required: true,
        type: Boolean,
      },
      top: {
        required: false,
        type: Boolean,
        default: false,
      },
      bottom: {
        required: false,
        type: Boolean,
        default: false,
      },
    },

    computed: {
      transition () {
        if (this.top) {
          return 'dialog-top-transition'
        }
        if (this.bottom) {
          return 'dialog-bottom-transition'
        }
        return 'dialog-transition'
      },
    },
  }
</script>
